import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface TestDataState {
  /** Persisted toggle. When true, test data is shown across the whole app
   *  (admin tabs + discovery + home stats). Survives navigation and page
   *  refreshes. Only resets when explicitly toggled off or on sign-out. */
  showTestData: boolean
  setShowTestData: (value: boolean) => void
}

export const useTestDataStore = create<TestDataState>()(
  persist(
    set => ({
      showTestData: false,
      setShowTestData: value => set({ showTestData: value })
    }),
    {
      name: 'godiving-test-data' // localStorage key
    }
  )
)
